import { ChevronLeft, CirclePlusIcon, EditIcon, FileDownIcon, ScanLineIcon, Trash2Icon } from 'lucide-react'
import React from 'react'
import { Sheet, SheetClose, SheetContent, SheetTrigger } from 'src/components/ui/sheet'
import { Bundle } from '../page'
import EditBundle from './EditBundle'
import AddBundleToFitdoc from './AddBundleToFitdoc'

type BundleSheetProps = {
    bundle: Bundle

    onClickAddScan?: () => void;
    onClickExport?: () => void;
    onClickDelete?: () => void;

    onEditBundle?: (bundle:Bundle) => void;
}

const BundleSheet = ({bundle, onClickAddScan, onClickExport, onClickDelete, onEditBundle}:BundleSheetProps) => {
  return (
    <>
    <Sheet>
        <SheetTrigger asChild>
            <div className='w-[100px] max-h-[124px] bg-neutral-100 h-full border border-b-0 rounded-t-sm overflow-hidden cursor-pointer flex justify-center items-center'>
                <img className='w-[100px] h-[124px] object-cover' src={bundle.documents[0]} alt={bundle.name}/>
            </div>
        </SheetTrigger>
        <SheetContent className='w-dvw max-w-[100dvw] flex flex-col justify-between h-dvh p-0 gap-0' hideClose position="left">
            <div className='grid grid-cols-[50px,auto,50px] p-2'>
                <div className='flex justify-start items-center'>
                <SheetClose asChild><button className='w-8 h-8 flex justify-center items-center'><ChevronLeft className='w-6 h-6'/></button></SheetClose>
                </div>
                <div className='flex justify-center items-center'>
                <p>{bundle.name}</p>
                </div>
                <div className='flex justify-end items-center'></div>
            </div>
            <div className='flex flex-col gap-2 p-2 items-center overflow-auto bg-neutral-100'>
                {bundle.documents.map((d, i)=>(
                <div key={`prev-${i}`} className='border'>
                    <img src={d} />
                </div>
                ))}
            </div>
            <div className='p-2 flex gap-4 overflow-auto min-h-20 z-10 relative'>
                
                <button onClick={()=>{onClickAddScan&&onClickAddScan()}} className='flex flex-col items-center justify-center gap-2 text-xs text-neutral-500 whitespace-nowrap'>
                    <ScanLineIcon className='w-5 h-5 min-h-5' strokeWidth={1.5}/>
                    Scannen
                </button>
                <EditBundle 
                    bundle={bundle} 
                    onSaveBundle={(bundle)=>{onEditBundle&&onEditBundle(bundle)}}
                    trigger={
                    <button className='flex flex-col items-center justify-center gap-2 text-xs text-neutral-500 whitespace-nowrap'>
                        <EditIcon className='w-5 h-5 min-h-5' strokeWidth={1.5}/>
                        Wijzigen
                    </button>}
                />
                <AddBundleToFitdoc 
                    bundle={bundle}
                />
                <button onClick={()=>{onClickExport&&onClickExport()}} className='flex flex-col items-center justify-center gap-2 text-xs text-neutral-500 whitespace-nowrap'>
                    <FileDownIcon className='w-5 h-5 min-h-5' strokeWidth={1.5}/>
                    Exporteren
                </button>
                <button onClick={()=>{onClickDelete&&onClickDelete()}} className='flex flex-col items-center justify-center gap-2 text-xs text-neutral-500 whitespace-nowrap'>
                    <Trash2Icon className='w-5 h-5 min-h-5' strokeWidth={1.5}/>
                    Verwijderen
                </button>
            </div>
        </SheetContent>
    </Sheet>
    </>
  )
}

export default BundleSheet